// extracted by mini-css-extract-plugin
export default {"wrap":"InputsRow__wrap--2_a","input":"InputsRow__input--1bm"};